import React, { useEffect, useState } from "react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Switch } from "@/components/ui/switch";
import { toast } from "sonner";
import { useGetTelephonySettingsQuery, useUpdateLineTypeIntelligenceMutation } from "@/store/rest_api";
import { apiErrorMessage } from "@/util/apiError";

export default function NumberValidationCard() {
  const { data: settings, isLoading } = useGetTelephonySettingsQuery();
  const [updateLineTypeIntelligence, { isLoading: isSaving }] = useUpdateLineTypeIntelligenceMutation();
  const [enabled, setEnabled] = useState(true);

  async function handleToggle(next: boolean) {
    setEnabled(next);
    try {
      await updateLineTypeIntelligence({ enabled: next }).unwrap();
      toast.success("Setting updated");
    } catch (error: unknown) {
      setEnabled(!next);
      toast.error(apiErrorMessage(error, "Failed to update setting"));
    }
  }

  useEffect(() => {
    if (settings) {
      setEnabled(settings.lineTypeIntelligenceEnabled);
    }
  }, [settings]);

  return (
    <Card>
      <CardHeader>
        <CardTitle>Number validation</CardTitle>
        <CardDescription>Check whether a number can receive texts before sending an SMS.</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="flex flex-row items-start justify-between rounded-lg border p-4">
          <div className="space-y-1 pr-4">
            <p className="text-base font-medium">Skip texts to landlines</p>
            <p className="text-sm text-muted-foreground">
              Before sending an SMS, check whether the number is a mobile or a landline so messages are not sent to
              landlines. Your organization is charged $0.01 per number checked. Results are cached for 90 days, so each
              number is only charged once per quarter.
            </p>
          </div>
          <Switch checked={enabled} disabled={isLoading || isSaving} onCheckedChange={handleToggle} />
        </div>
      </CardContent>
    </Card>
  );
}
